// extracted by mini-css-extract-plugin
export default {"container":"AddComment_container__LuIiA","label":"AddComment_label__c7zQv","textarea":"AddComment_textarea__HTIL1","submitButton":"AddComment_submitButton__0qkI+"};